import type { App } from 'vue'
import Vue3BaiduMapGL from 'vue3-baidu-map-gl'
import { cluster } from './utils/cluster'
import { ZnMap } from './components'

const install = function (app: App, options: any = {}) {
  app.component('ZnMap', ZnMap)

  const { ak, plugins, apiUrl, pluginsSourceLink } = options

  app.use(Vue3BaiduMapGL, {
    ak,
    plugins,
    apiUrl,
    pluginsSourceLink
  })

  // 加载聚合点算法
  const clusterScript = document.createElement('script')
  clusterScript.textContent = cluster
  document.body.appendChild(clusterScript)
}

export default {
  install
}
